/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'cross-flow-support.back-to-all-products': 'Zpět na všechny aplikace',
  'cross-flow-support.close': 'Zavřít',
  'cross-flow-support.product-store': 'Obchod s aplikacemi',
};
